import React from "react";
import { DateRangeFilter } from "../../../components/date-range-filter";

const NULL_SELECTION: number[] = [];

export const filterUpdatedAt = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
}: {
  selectedKeys: number[];
  setSelectedKeys: (selectedKeys: number[]) => void;
  confirm: () => void;
  clearFilters?: () => void;
}) => (
  <DateRangeFilter
    defaultValue={{
      from: selectedKeys[0] > 0 ? new Date(selectedKeys[0]) : null,
      to: selectedKeys[1] > 0 ? new Date(selectedKeys[1]) : null,
    }}
    onApplyFilter={(value) => {
      setSelectedKeys(
        value ? [value.from?.getTime() ?? 0, value.to?.getTime() ?? 0] : NULL_SELECTION
      );
      confirm();
    }}
    onClearFilter={() => {
      clearFilters && clearFilters();
      confirm();
    }}
  />
);
